function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1984(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.61,
    height: 13.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9142857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 6.7
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.4,
    width: 26.61,
    height: 18.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 22.72
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.03,
    width: 26.61,
    height: 20,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3333333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 42.03
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.03,
    width: 26.61,
    height: 28.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.661
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 66.355
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.68,
    width: 26.61,
    height: 30.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 96.00500000000001
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.33,
    width: 26.61,
    height: 33.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 127.91
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.49,
    width: 26.61,
    height: 33.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 161.12
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 177.75,
    width: 26.61,
    height: 33.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 194.735
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 211.72,
    width: 26.61,
    height: 34.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 228.74
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 245.76,
    width: 26.61,
    height: 34.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 263.105
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.45,
    width: 26.61,
    height: 38.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 299.755
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 319.06,
    width: 26.61,
    height: 39.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 338.6
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.14,
    width: 26.61,
    height: 39.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.801428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 378.09999999999997
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 398.06,
    width: 26.61,
    height: 48.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 422.085
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 446.11,
    width: 26.61,
    height: 49.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.661
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 470.875
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 495.63,
    width: 26.61,
    height: 49.82,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 520.54
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 545.46,
    width: 26.61,
    height: 50.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 570.745
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 596.03,
    width: 26.61,
    height: 51.07,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.32625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 621.5649999999999
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 647.1,
    width: 26.61,
    height: 52.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.305,
    y: 673.5500000000001
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 0,
    width: 34.71,
    height: 42.8,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.6775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.965,
    y: 21.4
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.32,
    y: 0,
    width: 34.83,
    height: 42.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 78.735,
    y: 21.4
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.15,
    y: 0,
    width: 35.2,
    height: 42.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.028571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.75,
    y: 21.4
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.35,
    y: 0,
    width: 36.15,
    height: 42.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0249999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.42499999999998,
    y: 21.4
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.51,
    y: 0,
    width: 40.42,
    height: 42.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.72,
    y: 21.4
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.92,
    y: 0,
    width: 40.5,
    height: 42.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.17,
    y: 21.4
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.42,
    y: 0,
    width: 41.9,
    height: 42.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.37,
    y: 21.4
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.31,
    y: 0,
    width: 42.72,
    height: 42.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.67,
    y: 21.4
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.03,
    y: 0,
    width: 42.91,
    height: 42.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.48499999999996,
    y: 21.4
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.94,
    y: 0,
    width: 43.02,
    height: 42.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.45,
    y: 21.4
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.95,
    y: 0,
    width: 43.84,
    height: 42.8,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8909090909090907
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.87,
    y: 21.4
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.79,
    y: 0,
    width: 44.8,
    height: 42.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.279999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.19,
    y: 21.4
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.59,
    y: 0,
    width: 46.1,
    height: 42.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.559999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.64,
    y: 21.4
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.69,
    y: 0,
    width: 47.11,
    height: 42.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.279999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.245,
    y: 21.4
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.8,
    y: 0,
    width: 49.45,
    height: 42.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.525,
    y: 21.4
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.25,
    y: 0,
    width: 49.75,
    height: 42.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.125,
    y: 21.4
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 42.8,
    width: 49.92,
    height: 44.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 64.865
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 86.93,
    width: 49.92,
    height: 45.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 109.435
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 131.93,
    width: 49.92,
    height: 46.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 155.07500000000002
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 178.22,
    width: 49.92,
    height: 48.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 202.235
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 226.25,
    width: 49.92,
    height: 48.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 250.43
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 274.61,
    width: 49.92,
    height: 48.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.07375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 298.90500000000003
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 323.2,
    width: 49.92,
    height: 50.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.984
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 348.3
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 373.4,
    width: 49.92,
    height: 52.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 399.525
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 425.65,
    width: 49.92,
    height: 52.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 452.13
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 478.62,
    width: 49.92,
    height: 54.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 505.85
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 533.08,
    width: 49.92,
    height: 54.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 560.3950000000001
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 587.71,
    width: 49.92,
    height: 54.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 615.125
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.61,
    y: 642.54,
    width: 49.92,
    height: 57.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.984
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.57,
    y: 671.27
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 42.8,
    width: 56,
    height: 57.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.53,
    y: 71.62
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.53,
    y: 42.8,
    width: 56.66,
    height: 57.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.86,
    y: 71.62
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.19,
    y: 42.8,
    width: 56.88,
    height: 57.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.63,
    y: 71.62
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.06,
    y: 42.8,
    width: 56.97,
    height: 57.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.138571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.545,
    y: 71.62
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.04,
    y: 42.8,
    width: 59.81,
    height: 57.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.205
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.94500000000005,
    y: 71.62
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.85,
    y: 42.8,
    width: 62.91,
    height: 57.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.234285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.305,
    y: 71.62
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.76,
    y: 42.8,
    width: 64.78,
    height: 57.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.404444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.15,
    y: 71.62
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.55,
    y: 42.8,
    width: 68.61,
    height: 57.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.205
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.855,
    y: 71.62
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.16,
    y: 42.8,
    width: 69.97,
    height: 57.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.205
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.145,
    y: 71.62
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.12,
    y: 42.8,
    width: 70.88,
    height: 57.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.234285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.56,
    y: 71.62
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 100.44,
    width: 64.81,
    height: 63.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.01142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 131.98
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 163.52,
    width: 64.81,
    height: 63.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.348
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 195.26000000000002
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 227.01,
    width: 64.81,
    height: 63.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.097142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 258.84999999999997
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 290.68,
    width: 64.81,
    height: 64.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.258571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 323.1
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 355.52,
    width: 64.81,
    height: 67.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.801666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 389.03999999999996
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 422.57,
    width: 64.81,
    height: 68.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.801666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 456.78
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 490.98,
    width: 64.81,
    height: 68.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.258571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 525.375
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 559.78,
    width: 64.81,
    height: 69.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.801666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 594.765
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.53,
    y: 629.75,
    width: 64.81,
    height: 70.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2011111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.935,
    y: 664.875
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 100.44,
    width: 62.8,
    height: 73.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.559999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.74,
    y: 137.31
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.14,
    y: 100.44,
    width: 63.05,
    height: 73.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.508333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.665,
    y: 137.31
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.19,
    y: 100.44,
    width: 66.53,
    height: 73.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.306000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.455,
    y: 137.31
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.73,
    y: 100.44,
    width: 66.93,
    height: 73.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.155000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.19500000000005,
    y: 137.31
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.66,
    y: 100.44,
    width: 73.21,
    height: 73.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.642
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.26500000000004,
    y: 137.31
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.86,
    y: 100.44,
    width: 73.55,
    height: 73.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.19375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.635,
    y: 137.31
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.41,
    y: 100.44,
    width: 74.51,
    height: 73.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.665,
    y: 137.31
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.92,
    y: 100.44,
    width: 78.08,
    height: 73.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.9599999999999,
    y: 137.31
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 174.18,
    width: 83.15,
    height: 70.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.5525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 209.285
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 244.39,
    width: 83.15,
    height: 72.32,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.035555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 280.54999999999995
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 316.71,
    width: 83.15,
    height: 74.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.270000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 353.92499999999995
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 391.14,
    width: 83.15,
    height: 75.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.174000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 429.075
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 467.01,
    width: 83.15,
    height: 76.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.948571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 505.33
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 543.65,
    width: 83.15,
    height: 77.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.731
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 582.305
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.34,
    y: 620.96,
    width: 83.15,
    height: 79.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.808000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.91500000000002,
    y: 660.48
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.49,
    y: 174.18,
    width: 88.7,
    height: 78.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.84000000000003,
    y: 213.61
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.19,
    y: 174.18,
    width: 92.9,
    height: 78.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.64,
    y: 213.61
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.09,
    y: 174.18,
    width: 95.1,
    height: 78.86,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.64,
    y: 213.61
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.19,
    y: 174.18,
    width: 96.26,
    height: 78.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.265714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.32,
    y: 213.61
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.45,
    y: 174.18,
    width: 102.55,
    height: 78.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.725,
    y: 213.61
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.49,
    y: 253.04,
    width: 98.44,
    height: 83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.71000000000004,
    y: 294.53999999999996
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.49,
    y: 336.04,
    width: 98.44,
    height: 83.4,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.581818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.71000000000004,
    y: 377.74
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.49,
    y: 419.45,
    width: 98.44,
    height: 85.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.71000000000004,
    y: 462.2
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.49,
    y: 504.95,
    width: 98.44,
    height: 96.1,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.0125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.71000000000004,
    y: 553
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.49,
    y: 601.04,
    width: 98.44,
    height: 98.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.062857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.71000000000004,
    y: 650.52
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.93,
    y: 253.04,
    width: 119.2,
    height: 100.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.53000000000003,
    y: 303.485
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.13,
    y: 253.04,
    width: 121.27,
    height: 100.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.089
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.765,
    y: 303.485
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.4,
    y: 253.04,
    width: 136.6,
    height: 100.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.61125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.6999999999999,
    y: 303.485
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.93,
    y: 353.93,
    width: 102.71,
    height: 135.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.118333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.285,
    y: 421.46000000000004
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.93,
    y: 488.99,
    width: 102.71,
    height: 211.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.672857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.285,
    y: 594.495
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.64,
    y: 353.93,
    width: 130.34,
    height: 206.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.81,
    y: 457.045
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.98,
    y: 353.93,
    width: 144.02,
    height: 206.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 36.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.99,
    y: 457.045
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.64,
    y: 560.16,
    width: 274.36,
    height: 139.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.712727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.8199999999999,
    y: 630.0799999999999
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1984);
export default __webpack_public_path__ + "static/media/1984.2df2619b147e26e2f1d63efe07fe1c11.svg";
export { ForwardRef as ReactComponent };